// extracted by mini-css-extract-plugin
module.exports = {"container":"BundleOfferAside_container__Xr_0L"};